export default "__VITE_ASSET__DnHMB28y__"